<div class="form-floating" style="margin-bottom: 20px;">
  <select class="form-select form-select-md" (change)="changeMakeCode($event.target)" id="makecode" [disabled]="disabled">
    <option value="" selected="selected">Select Model Code</option>
    <option *ngFor="let makeCode of makeCodes" value="{{makeCode}}" [selected]="makeCode == makecode">{{makeCode}}
    </option>
  </select>
  <label for="makecode">Model Code</label>
</div>
